import { render, staticRenderFns } from "./ExInputSuffixClear.vue?vue&type=template&id=3383881e&scoped=true"
import script from "./ExInputSuffixClear.vue?vue&type=script&lang=js"
export * from "./ExInputSuffixClear.vue?vue&type=script&lang=js"
import style0 from "./ExInputSuffixClear.vue?vue&type=style&index=0&id=3383881e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3383881e",
  null
  
)

export default component.exports